import DataTypes from './DataTypes';

export function loadDisclosureData (data) {
  return {
    type: DataTypes.GET_DISCLOSURE_DATA_REQUEST,
    payload: data
  };
}

export function loadPatientData (data) {
  return {
    type: DataTypes.GET_PATIENT_DATA_REQUEST,
    payload: data
  };
}

export function loadRecordDetail (data) {
  return {
    type: DataTypes.GET_DATA_RECORD_DETAIL_REQUEST,
    payload: data
  };
}

export function loadYears (data) {
  return {
    type: DataTypes.GET_YEARS_REQUEST,
    payload: data
  };
}

export function loadRootSections (data) {
  return {
    type: DataTypes.GET_ROOT_SECTIONS_REQUEST,
    payload: data
  };
}

export function exportData (data) {
  return {
    type: DataTypes.EXPORT_DATA_REQUEST,
    payload: data
  };
}

export function downloadPDF (data) {
  return {
    type: DataTypes.DOWNLOAD_DATA_REQUEST,
    payload: data
  };
}

export function deleteDataRecord (data) {
  return {
    type: DataTypes.DELETE_DATA_RECORD_REQUEST,
    payload: data
  };
}

export function updateDataRecord (data) {
  return {
    type: DataTypes.UPDATE_DATA_RECORD_REQUEST,
    payload: data
  };
}

export function checkUpdateDataRecordProgress (data) {
  return {
    type: DataTypes.CHECK_UPDATE_DATA_RECORD_PROGRESS_REQUEST,
    payload: data
  };
}

export function moveDataRecordToDataRecordPreview (data) {
  return {
    type: DataTypes.UPDATE_DATA_RECORD_TO_PREVIEW,
    payload: data
  };
}

export function loadPdfPreview (data) {
  return {
    type: DataTypes.GET_PDF_PREVIEW_REQUEST,
    payload: data
  };
}

export function updatePublishPDF (data) {
  return {
    type: DataTypes.UPDATE_PUBLISH_PDF_REQUEST,
    payload: data
  };
}
